import React from 'react';

const TextError = (props) => {
  return <span className="text-danger d-block">{props.children}</span>;
};

export default TextError;
